import { defineComponent, ref, computed, createElementBlock, openBlock, createBlock, createCommentVNode, Fragment, renderList, normalizeClass, createElementVNode, resolveDynamicComponent, withCtx, createTextVNode, toDisplayString, createVNode, mergeProps } from 'vue';
import _sfc_main$1 from './basler-components.es100.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es112.js';
/* empty css                        */
import RenderlessComponent from './basler-components.es233.js';
import _sfc_main$3 from './basler-components.es181.js';
/* empty css                        */

const _hoisted_1 = { class: "product-specs" };
const _hoisted_2 = { class: "product-specs__group-header" };
const _hoisted_3 = { class: "product-specs__group-content" };
const _hoisted_4 = { scope: "row" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "product-specs__images"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  key: 2,
  class: "product-specs__checklist"
};
const _hoisted_9 = { class: "product-specs__checklist-list" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductSpecs",
  props: {
    groups: {},
    headlineTag: { default: "h4" },
    lightboxGallery: {}
  },
  setup(__props) {
    const props = __props;
    const lightboxGalleryRef = ref(null);
    const lightboxGalleryAvailable = computed(() => {
      return props.lightboxGallery && lightboxGalleryRef.value;
    });
    const renderLightboxTriggerBtn = (lightboxIndex) => {
      return lightboxGalleryAvailable.value && typeof lightboxIndex === "number";
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group, groupIndex) => {
          return openBlock(), createElementBlock("div", {
            key: groupIndex,
            class: normalizeClass({
              "product-specs__group": true,
              [`product-specs__group--${group.type}`]: true
            })
          }, [
            createElementVNode("header", _hoisted_2, [
              (openBlock(), createBlock(resolveDynamicComponent(_ctx.headlineTag), {
                class: normalizeClass({
                  "product-specs__group-headline": true,
                  [`product-specs__group-headline--${group.type}`]: true
                })
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(group.title), 1)
                ]),
                _: 2
              }, 1032, ["class"]))
            ]),
            createElementVNode("div", _hoisted_3, [
              group.type === "table" ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                class: "product-specs__spec-table"
              }, {
                default: withCtx(() => [
                  createElementVNode("table", null, [
                    createElementVNode("tbody", null, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(group.specs, (item, index) => {
                        return openBlock(), createElementBlock("tr", { key: index }, [
                          createElementVNode("th", _hoisted_4, toDisplayString(item.label), 1),
                          createElementVNode("td", {
                            innerHTML: item.value,
                            class: "rte-text"
                          }, null, 8, _hoisted_5)
                        ]);
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)) : createCommentVNode("", true),
              group.type === "images" ? (openBlock(), createElementBlock("div", _hoisted_6, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(group.images, (image, imageIndex) => {
                  return openBlock(), createElementBlock("figure", {
                    key: imageIndex,
                    class: "product-specs__image"
                  }, [
                    (openBlock(), createBlock(resolveDynamicComponent(renderLightboxTriggerBtn(image.lightboxIndex) ? "button" : RenderlessComponent), {
                      type: renderLightboxTriggerBtn(image.lightboxIndex) ? "button" : void 0,
                      class: "product-specs__image-btn",
                      "aria-label": renderLightboxTriggerBtn(image.lightboxIndex) ? _ctx.lightboxGallery?.triggerBtnLabel : void 0,
                      onClick: ($event) => renderLightboxTriggerBtn(image.lightboxIndex) ? lightboxGalleryRef.value.openLightbox(image.lightboxIndex, $event) : void 0
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2, {
                          media: image.mediaContent.media,
                          lazyload: image.mediaContent.lazyload,
                          cols: image.mediaContent.cols
                        }, null, 8, ["media", "lazyload", "cols"])
                      ]),
                      _: 2
                    }, 1032, ["type", "aria-label", "onClick"])),
                    image.downloadLink && image.downloadLinkText ? (openBlock(), createElementBlock("a", {
                      key: 0,
                      href: image.downloadLink,
                      class: "product-specs__image-download-link"
                    }, toDisplayString(image.downloadLinkText), 9, _hoisted_7)) : createCommentVNode("", true)
                  ]);
                }), 128))
              ])) : createCommentVNode("", true),
              group.type === "checklist" ? (openBlock(), createElementBlock("div", _hoisted_8, [
                createElementVNode("ul", _hoisted_9, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item, itemIndex) => {
                    return openBlock(), createElementBlock("li", {
                      key: itemIndex,
                      class: "product-specs__checklist-list-item"
                    }, toDisplayString(item), 1);
                  }), 128))
                ])
              ])) : createCommentVNode("", true)
            ])
          ], 2);
        }), 128)),
        _ctx.lightboxGallery ? (openBlock(), createBlock(_sfc_main$3, mergeProps({
          key: 0,
          ref_key: "lightboxGalleryRef",
          ref: lightboxGalleryRef
        }, _ctx.lightboxGallery), null, 16)) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
